// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
============
Generals Styles
============
*/
/* 
============
Variables
============
*/
/* 
============
Generals Styles
============
*/
body {
  background-color: hsl(217, 28%, 15%);
  font-family: "Open Sans", sans-serif;
  color: #fff;
}

img {
  max-width: 100%;
}

a {
  text-decoration: none;
}

ul,
ol,
li {
  list-style-type: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.cta,
li,
.list-item {
  font-family: "Raleway", sans-serif;
}

p {
  line-height: 1.8;
}

.btn {
  background-color: hsl(176, 68%, 64%);
  padding: 0.625rem 2rem;
  color: #fff;
  border-radius: 30px;
  display: block;
  margin: 0 auto;
}

.btn-first {
  padding: 0.625rem 4rem;
  margin: 0rem auto 23rem;
}

.accessAnywhere {
  background-color: hsl(218, 28%, 13%);
  margin-top: -57px;
}

.fyloworks {
  color: hsl(176, 68%, 64%);
}

.footer-bg-color {
  background-color: hsl(216, 53%, 9%);
}

.testimonials-bg-color {
  background-color: hsl(219, 30%, 18%);
}

.getaccess-bg-color {
  background-color: hsl(217, 28%, 15%);
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #0b1523;
  border-radius: 50%;
  border: 1px solid #fff;
  text-align: center;
}

.icon-circle i {
  margin: 0;
}

.fb-icon {
  background-color: #0b1523;
}

/* 
============
Footer Section
============
*/
.attribution {
  font-size: 11px;
  text-align: center;
}

.attribution a {
  color: hsl(228, 45%, 44%);
}

@media (max-width: 375px) {
  .margintop {
    margin-top: -49px;
  }
  .text-top {
    margin-top: -189px;
  }
  .btn-first {
    margin: 0rem auto -16rem;
  }
  .smmtop-80 {
    margin-top: 17.8125rem;
  }
  .mt-60 {
    margin-top: 0rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA;;;;CAAA;ACAA;;;;CAAA;ADOA;;;;CAAA;AAKA;EACE,oCCRW;EDSX,oCAAA;EACA,WCTW;ADab;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,qBAAA;AAMF;;AAJA;;;EAGE,qBAAA;AAOF;;AAJA;;;;;;;;;EASE,kCAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,oCAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAOF;;AALA;EACE,sBAAA;EACA,uBAAA;AAQF;;AANA;EACE,oCCnDiB;EDoDjB,iBAAA;AASF;;AANA;EACE,yBAAA;AASF;;AANA;EACE,mCAAA;AASF;;AANA;EACE,oCAAA;AASF;;AANA;EACE,oCAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AASF;;AANA;EACE,SAAA;AASF;;AANA;EACE,yBAAA;AASF;;AANA;;;;CAAA;AAKA;EACE,eAAA;EACA,kBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AAPA;EACE;IACE,iBAAA;EAUF;EARA;IACE,kBAAA;EAUF;EARA;IACE,wBAAA;EAUF;EAPA;IACE,sBAAA;EASF;EANA;IACE,gBAAA;EAQF;AACF","sourcesContent":["/* \r\n============\r\nGenerals Styles\r\n============\r\n*/\r\n@import \"./variables\";\r\n\r\n/* \r\n============\r\nGenerals Styles\r\n============\r\n*/\r\nbody {\r\n  background-color: $body-color;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  color: $text-color;\r\n}\r\nimg {\r\n  max-width: 100%;\r\n}\r\na {\r\n  text-decoration: none;\r\n}\r\nul,\r\nol,\r\nli {\r\n  list-style-type: none;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.cta,\r\nli,\r\n.list-item {\r\n  font-family: \"Raleway\", sans-serif;\r\n}\r\n\r\np {\r\n  line-height: 1.8;\r\n}\r\n\r\n.btn {\r\n  background-color: hsl(176, 68%, 64%);\r\n  padding: 0.625rem 2rem;\r\n  color: #fff;\r\n  border-radius: 30px;\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n.btn-first {\r\n  padding: 0.625rem 4rem;\r\n  margin: 0rem auto 23rem;\r\n}\r\n.accessAnywhere {\r\n  background-color: $main-background;\r\n  margin-top: -57px;\r\n}\r\n\r\n.fyloworks {\r\n  color: hsl(176, 68%, 64%);\r\n}\r\n\r\n.footer-bg-color {\r\n  background-color: hsl(216, 53%, 9%);\r\n}\r\n\r\n.testimonials-bg-color {\r\n  background-color: hsl(219, 30%, 18%);\r\n}\r\n\r\n.getaccess-bg-color {\r\n  background-color: hsl(217, 28%, 15%);\r\n}\r\n\r\n.icon-circle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: #0b1523;\r\n  border-radius: 50%;\r\n  border: 1px solid #fff;\r\n  text-align: center;\r\n}\r\n\r\n.icon-circle i {\r\n  margin: 0;\r\n}\r\n\r\n.fb-icon {\r\n  background-color: #0b1523;\r\n}\r\n\r\n/* \r\n============\r\nFooter Section\r\n============\r\n*/\r\n.attribution {\r\n  font-size: 11px;\r\n  text-align: center;\r\n}\r\n.attribution a {\r\n  color: hsl(228, 45%, 44%);\r\n}\r\n\r\n@media (max-width: 375px) {\r\n  .margintop {\r\n    margin-top: -49px;\r\n  }\r\n  .text-top {\r\n    margin-top: -189px;\r\n  }\r\n  .btn-first {\r\n    margin: 0rem auto -16rem;\r\n  }\r\n\r\n  .smmtop-80 {\r\n    margin-top: 17.8125rem;\r\n  }\r\n\r\n  .mt-60 {\r\n    margin-top: 0rem;\r\n  }\r\n}\r\n","/* \r\n============\r\nVariables\r\n============\r\n*/\r\n$body-color: hsl(217, 28%, 15%);\r\n$text-color: #fff;\r\n$main-background:  hsl(218, 28%, 13%); "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
